module.exports = __webpack_public_path__ + "images/help_v2/case-chan-2650e92b080bfc5c72288e115ced1cd0.jpg";